/*
 * Jira Ticket:
 * Created Date: Wed, 3rd Jun 2020, 16:29:49 pm
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import React from 'react';
import { TextInput } from 'react-admin';
import { columnStyles } from 'styles';

const AdvertAnalytics = props => {
  const classes = columnStyles();
  return (
    <div className={classes.root}>
      <div className={classes.column}>
        <TextInput
          source="statistics.impressions"
          label="resources.Advert.fields.impressions"
          disabled={true}
        />
        <TextInput
          source="statistics.engagements"
          label="resources.Advert.fields.engagements"
          disabled={true}
        />
      </div>
    </div>
  );
};

export default AdvertAnalytics;
